module.exports = __webpack_public_path__ + "static/img/120001.64f5de3f.png";